import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'

import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'
import message from '@/ddv2.library/messages'
import date from '@/ddv2.library/date'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdListHeader = () => import('@/components/DdListHeader')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdTextBox = () => import('@/components/DdTextBox')
const DdYearMonthBoxWithSelector = () => import('@/components/DdYearMonthBoxWithSelector')

export default {
  name: 'SeikyuList',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdNumericBox,
    DdListHeader,
    DdRadioButton,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox,
    DdYearMonthBoxWithSelector
  },
  data: () => ({
    selected: [{}],
    itemsPerPage: 25,
    page: 1,
    isCsvDownloader: false,
    isPdfDownloader: false,
    isXlsDownloader: false,

    balkOperation: '一括操作',
    conditions: {
      seikyusho: '',
      torihikisakiCd: '',
      seikyuNo: '',
      seikyuYm: '',
      shimeDay: '',
      shiborikomiStartDay: '',
      shiborikomiEndDay: '',
      seikyushoKarihakko: '',
      eigyoshoCd: '',
      latestOnlyFlg: true,
      seikyuZeroFlg: '',
      shanaiTantoshaCd: '',
      nonOutputSummaryFlg: false
    },
    conditionDetails: [
      { key: 'seikyuYm', name: '請求年月', value: 'seikyuYm', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'shimeDay', name: '締日', value: 'shimeDay', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'eigyoshoCd', name: '営業所', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msteigyosho' },
      { key: 'torihikisakiCd', name: '請求先', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'shiborikomiDayFromTo', name: '絞込日', value: 'shiborikomiDayFromTo', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'seikyuNo', name: '請求書No', value: 'seikyuNo', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'targetSeikyusho', name: '請求書出力状況', value: 'targetSeikyusho', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'targetKarihakko', name: '仮発行', value: 'targetKarihakko', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'latestOnlyFlg', name: '最新のみを表示する', value: null, type: 'checkbox', delete: true, showValue: false, convertValue: false },
      { key: 'seikyuZeroFlg', name: '当月請求無しも表示する', value: null, type: 'checkbox', delete: true, showValue: false, convertValue: false }
    ],
    headersSeikyusakiList: header.mstTorihikisakiHeaders,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersJininList: header.mstJininHeaders,
    // 表示制御
    dispSeikyusho: '',
    dispSeikyuIchiranHyo: '',
    dispSeikyuIchiranCsv: '',
    modeKengen: 0,
    CancelButtonDisp: false,
    PrintButtonDisp: false,
    lastShimeYmd: ''
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 絞込日
    'conditions.shiborikomiStartDay': function (n) {
      var shiborikomiDayFromTo = ![undefined, null, ''].includes(this.conditions.shiborikomiStartDay) ? this.conditions.shiborikomiStartDay : ''
      shiborikomiDayFromTo = shiborikomiDayFromTo + (![undefined, null, ''].includes(this.conditions.shiborikomiEndDay) ? '～' + this.conditions.shiborikomiEndDay : '')
      this.conditions.shiborikomiDayFromTo = shiborikomiDayFromTo
    },
    'conditions.shiborikomiEndDay': function (n) {
      var shiborikomiDayFromTo = ![undefined, null, ''].includes(this.conditions.shiborikomiStartDay) ? this.conditions.shiborikomiStartDay : ''
      shiborikomiDayFromTo = shiborikomiDayFromTo + (![undefined, null, ''].includes(this.conditions.shiborikomiEndDay) ? '～' + this.conditions.shiborikomiEndDay : '')
      this.conditions.shiborikomiDayFromTo = shiborikomiDayFromTo
    },
    // 請求書
    'conditions.seikyusho': function (n) {
      this.conditions.targetSeikyusho = this.conditions.seikyusho === '01' ? '未出力' : this.conditions.seikyusho === '02' ? '出力済み（取消除く）' : this.conditions.seikyusho === '03' ? '出力済（取消含む）' : '全て'
    },
    // 仮発行
    'conditions.seikyushoKarihakko': function (n) {
      this.conditions.targetKarihakko = this.conditions.seikyushoKarihakko === '01' ? '含む' : '含まない'
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      seikyusakiList: 'DDMasters/vwCMstTorihikisakiGetSeikyusaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      usersEigyosho: 'users/eigyoshoCd',
      JininList: 'DDMasters/vwCMstEigyoshoJininList',
      messageList: 'DDMasters/msysMessage',
      systemConfigList: 'DDMasters/msysSystemConfig',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredSeikyusakiList () {
      // 請求先限定
      const target = filter.dateFormatter(new Date())
      return this.seikyusakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredJininList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.JininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
              (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        if (elem.jininNmSei) { elem.hakkoshaNm = elem.jininNmSei + (elem.jininNmMei ? elem.jininNmMei : '') }
        if (elem.torihikisakiCd) { elem.torihikisakiCdNm = elem.torihikisakiCd + ':' + elem.torihikisakiNm }
        elem.shimeDayDisp = (elem.shimeDay === '99' ? '末' : Number(elem.shimeDay)) + '日'
        elem.konkaiSeikyuKingaku = filter.numericFormatter(elem.konkaiSeikyuKingaku) + '円'
        elem.kihonUnchiGokei = filter.numericFormatter(elem.kihonUnchiGokei) + '円'
        elem.warimashiKingakuGokei = filter.numericFormatter(elem.warimashiKingakuGokei) + '円'
        elem.kazeiKingakuGokei = filter.numericFormatter(elem.kazeiKingakuGokei) + '円'
        elem.konkaiTax = filter.numericFormatter(elem.konkaiTax) + '円'
        elem.hiwayPriceGokei = filter.numericFormatter(elem.hiwayPriceGokei) + '円'
        elem.uchizeiKingakuGokei = filter.numericFormatter(elem.uchizeiKingakuGokei) + '円'
        elem.hikazeiKingakuGokei = filter.numericFormatter(elem.hikazeiKingakuGokei) + '円'
        if (elem.seikyushoHakkoYmd) { elem.seikyushoHakkoYmd = elem.seikyusho !== '未出力' ? filter.dateYmdHmsFormatter(elem.seikyushoHakkoYmd) : '' }
        if (elem.seikyuYmd) { elem.seikyuYmd = filter.dateFormatter(elem.seikyuYmd) }
        if (elem.nyukinYoteiYmd) { elem.nyukinYoteiYmd = filter.dateFormatter(elem.nyukinYoteiYmd) }
        if (elem.shiborikomiStartYmd || elem.shiborikomiEndYmd) { elem.shiborikomiYmd = filter.dateFormatter(elem.shiborikomiStartYmd) + ' ~ ' + filter.dateFormatter(elem.shiborikomiEndYmd) }
        if (elem.torikeshiJininNmSei) { elem.torikeshishaNm = elem.torikeshiJininNmSei + (elem.torikeshiJininNmMei ? elem.torikeshiJininNmMei : '') }
        if (elem.torikeshiYmd) { elem.torikeshiYmd = filter.dateYmdHmsFormatter(elem.torikeshiYmd) }
        if (elem.mailSndrcvDate) { elem.mailSndrcvDate = filter.dateYmdHmsFormatter(elem.mailSndrcvDate) }

        if (elem.seikyushoKarihakkoFlg) {
          elem.seikyushoStatus = 1
          elem.outputStatus = [undefined, null].includes(elem.trMailSojushinRirekiId) ? 1 : 2
        } else if (elem.seikyusho === '取消済') {
          elem.seikyushoStatus = 9
          elem.outputStatus = 0
        } else if (elem.seikyusho === '出力済') {
          elem.seikyushoStatus = 2
          elem.outputStatus = [undefined, null].includes(elem.trMailSojushinRirekiId) ? 1 : 2
        } else {
          elem.seikyushoStatus = 0
          elem.outputStatus = 0
        }

        return elem
      })
    },
    isOutputButtonDisabled () {
      return this.rows.length === 0
    },
    isSelected () {
      if (this.selected.length === 0 || this.selected.length > 10) { return true }
      return false
    },
    isCancelButtonDisabled  () {
      if (this.selected.length === 0) { return true }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
    this.selected = []
    this.page = 1
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['vwcmsttorihikisakigetseikyusaki', 'msttorihikisaki', 'msteigyosho', 'vwcmsteigyoshojininlist', 'msyssystemconfig'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: '明細', value: 'actions', align: 'center', sortable: false },
              // { text: '請求書', value: 'seikyusho' },
              // { text: '仮発行', value: 'seikyushoKarihakkoFlg', align: 'center' },
              { text: 'ステータス', value: 'seikyushoStatus', align: 'center' },
              { text: '出力種別', value: 'outputStatus', align: 'center' },
              { text: '請求番号', value: 'seikyuNo' },
              { text: '請求先', value: 'torihikisakiNm' },
              { text: '締日', value: 'shimeDayDisp', align: 'center' },
              { text: '当月請求額', value: 'konkaiSeikyuKingaku', align: 'right' },
              { text: '(運賃)', value: 'kihonUnchiGokei', align: 'right' },
              { text: '(割増)', value: 'warimashiKingakuGokei', align: 'right' },
              { text: '(その他課税)', value: 'kazeiKingakuGokei', align: 'right' },
              { text: '(消費税)', value: 'konkaiTax', align: 'right' },
              { text: '(高速代)', value: 'hiwayPriceGokei', align: 'right' },
              { text: '(その他内税)', value: 'uchizeiKingakuGokei', align: 'right' },
              { text: '(その他非課税)', value: 'hikazeiKingakuGokei', align: 'right' },
              { text: '発行者', value: 'hakkoshaNm' },
              { text: '発行日', value: 'seikyushoHakkoYmd' },
              { text: 'メール送信日', value: 'mailSndrcvDate' },
              { text: '取消者', value: 'torikeshishaNm' },
              { text: '取消日', value: 'torikeshiYmd' },
              { text: '請求日', value: 'seikyuYmd' },
              { text: '入金予定日', value: 'nyukinYoteiYmd' },
              { text: '営業所', value: 'eigyoshoNm' }
              // { text: '固有コード1', value: 'userCustomCd1' },
              // { text: '固有コード2', value: 'userCustomCd2' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            var today = new Date()

            // URLパラメータ参照
            var wTorihikisakiCd = ''
            var wSeikyuNo = ''
            var wSeikyuYm = ''
            const query = self.$route.query
            if (![undefined, null, ''].includes(query.scd)) {
              wTorihikisakiCd = query.scd
            }
            if (![undefined, null, ''].includes(query.sno)) {
              wSeikyuNo = query.sno
            }
            if (wTorihikisakiCd === '' && wSeikyuNo === '') {
              wSeikyuYm = ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth() + 1)).slice(-2)
            }

            self.conditions = {
              seikyusho: '01',
              torihikisakiCd: wTorihikisakiCd,
              seikyuNo: wSeikyuNo,
              seikyuYm: wSeikyuYm,
              shimeDay: '',
              shiborikomiStartDay: '',
              shiborikomiEndDay: '',
              seikyushoKarihakko: '01',
              latestOnlyFlg: true,
              eigyoshoCd: self.userEigyoshoCd,
              seikyuZeroFlg: '',
              shanaiTantoshaCd: '',
              // 簡易表示用
              shiborikomiDayFromTo: null,
              targetSeikyusho: null,
              targetKarihakko: null
            }
            self.selected = []
            self.page = 1
            self.CancelButtonDisp = false
            self.PrintButtonDisp = false
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            if (self.modeKengen !== 0) {
              this.PrintButtonDisp = true
            }

            if (self.modeKengen === 2) {
              this.CancelButtonDisp = true
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
              if (![undefined, null, ''].includes(self.conditions.torihikisakiCd) || ![undefined, null, ''].includes(self.conditions.seikyuNo)) {
                self.onSearchButtonClick()
              }
            })

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
      this.getShimeJisseki()
    },
    settingSeikyuYm: function (p) {
      this.conditions.seikyuYm = p
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      this.clearSummaryMessage()
      const self = this
      self.Effects.loadStart()
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/d2bild0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            seikyusho: self.conditions.seikyusho,
            seikyushoKarihakko: self.conditions.seikyushoKarihakko,
            seikyuZeroFlg: self.conditions.seikyuZeroFlg
          }
        }
      }
      this.search(opt)
      this.getShimeJisseki()
    },
    onRemoveConditionClick: function (itemNm, type) {
      if (type === 'checkbox') {
        this.conditions[itemNm] = false
      } else {
        this.conditions[itemNm] = null
      }
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            var today = new Date()
            self.conditions = {
              seikyusho: '01',
              torihikisakiCd: '',
              seikyuNo: '',
              seikyuYm: ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth() + 1)).slice(-2),
              shimeDay: '',
              shiborikomiStartDay: '',
              shiborikomiEndDay: '',
              seikyushoKarihakko: '01',
              latestOnlyFlg: true,
              eigyoshoCd: self.userEigyoshoCd,
              seikyuZeroFlg: '',
              shanaiTantoshaCd: '',
              // 簡易表示用
              shiborikomiDayFromTo: null,
              targetSeikyusho: null,
              targetKarihakko: null
            }
            self.selected = []
            self.page = 1
            self.rows = []
            self.CancelButtonDisp = false
            self.PrintButtonDisp = false
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowDoubleClick: function (e, f) {
      console.log('onRowDoubleClick', e, f)
      if (!this.getSystemConfigInfo()) { return }
      this.Effects.loadStart()
      var param = {
        seikyuId: f.item.id,
        seikyuNo: f.item.seikyuNo,
        seikyusho: f.item.seikyusho,
        seikyuYmd: f.item.seikyuYmd,
        shimeYm: f.item.seikyuYm,
        shimeDay: f.item.shimeDay,
        seikyuShimeDate: f.item.seikyuShimeDate,
        shiborikomiStartYmd: f.item.shiborikomiStartYmd,
        shiborikomiEndYmd: f.item.shiborikomiEndYmd,
        seikyusakiCd: f.item.torihikisakiCd,
        seikyusakiNm: f.item.torihikisakiNm,
        eigyoshoCd: f.item.eigyoshoCd,
        kariHakkoFlg: f.item.seikyushoKarihakkoFlg,
        seikyuZeroFlg: f.item.seikyuZeroFlg
      }
      this.transition(1, param)
    },
    onRowEditDetailButtonClick: function (item) {
      console.log('onRowEditDetailButtonClick', item)
      if (!this.getSystemConfigInfo()) { return }
      this.Effects.loadStart()
      var param = {
        seikyuId: item.id,
        seikyuNo: item.seikyuNo,
        seikyusho: item.seikyusho,
        seikyuYmd: item.seikyuYmd,
        shimeYm: item.seikyuYm,
        shimeDay: item.shimeDay,
        seikyuShimeDate: item.seikyuShimeDate,
        shiborikomiStartYmd: item.shiborikomiStartYmd,
        shiborikomiEndYmd: item.shiborikomiEndYmd,
        seikyusakiCd: item.torihikisakiCd,
        seikyusakiNm: item.torihikisakiNm,
        eigyoshoCd: item.eigyoshoCd,
        kariHakkoFlg: item.seikyushoKarihakkoFlg,
        seikyuZeroFlg: item.seikyuZeroFlg
      }
      this.transition(1, param)
    },
    onCsvButtonClick: function (e) {
      this.Effects.loadStart()
      this.clearSummaryMessage()
      this.HttpClient
        .post('/api/v1/d2bild0010/csvdownload', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('seikyushoDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = `請求一覧_${this.getTimeStamp()}.csv`
          elem.click()
          this.setInvalidSummaryMessage('COMI0006')
          this.Effects.loadComplete()
        })
    },
    onPdfButtonClick: function (e) {
      this.Effects.loadStart()
      this.clearSummaryMessage()
      this.dispSeikyuIchiranHyo = `請求一覧表_${this.getTimeStamp()}.pdf`
      this.HttpClient
        .requestFileByPost('/api/v1/d2bild0010/pdfdownload', this.conditions)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('seikyushoDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = `請求一覧_${this.getTimeStamp()}.pdf`
          elem.click()
          this.setInvalidSummaryMessage('COMI0007')
          this.Effects.loadComplete()
        })
    },
    onXlsOutputButtonClick: function (e) {
      this.isXlsDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/d2bild0010/ExcelOutput', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('seikyushoDownload')
          this.isXlsDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '請求一覧_' + ts + '.xlsx'
          elem.click()
        })
    },

    onCancelButtonClick: function (e) {
      this.clearSummaryMessage()

      var checkResult = this.checkSelected('出力済')
      if (checkResult !== '') {
        this.setInvalidSummaryMessage('BILE0004')
        return false
      }
      // 仮発行だった場合、エラー
      for (const row of this.selected) {
        if (row.seikyushoKarihakkoFlg !== false) {
          this.setInvalidSummaryMessage('BILE0004')
          return false
        }
      }
      // 請求消込を行ったデータだった場合、エラー
      for (const row of this.selected) {
        if (row.trSeikyuKeshikomiMeisaiId !== null) {
          this.setInvalidSummaryMessage('BILE0006')
          return false
        }
      }
      // 月次確定処理を行ったデータだった場合、エラー
      for (const row of this.selected) {
        if (row.trKessanGetsujiKanriId !== null) {
          this.setInvalidSummaryMessage('BZME0001')
          return false
        }
      }
      const p = modals.showConfirm
      p('COMQ0003').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        this.selected = this.removeFilterTable(this.selected)
        this.HttpClient.post('/api/v1/d2bild0010/seikyucancel', this.selected)
          .then((data) => {
            if (data.isValid) {
              this.loadFromCache()
                .then((c) => {
                  this.conditions = c.value.conditions || {}
                  this.onSearchButtonClick()
                })
                .then(() => {
                  this.setInvalidSummaryMessage('COMI0005')
                  // this.Effects.loadComplete()
                })
            } else {
              this.Effects.loadComplete()
              this.setInvalidSummaryMessage(data.summaryMessage)
            }
          })
      })
    },
    onPrintButtonClick: function (karihakkoFlg) {
      var kariFlg = karihakkoFlg
      this.clearSummaryMessage()

      console.log(this.selected)
      var checkResult = this.checkSelected('未出力')
      if (checkResult !== '') {
        if (kariFlg === false) { this.setInvalidSummaryMessage('BILE0002') }
        if (kariFlg === true) { this.setInvalidSummaryMessage('BILE0003') }
        return false
      }
      if (this.lastShimeYmd !== '') {
        if (this.checkShimeJisseki() !== '') {
          this.setInvalidSummaryMessage('BZME0001')
          return false
        }
      }
      this.Effects.loadStart()
      var path = null
      if (kariFlg === false) {
        path = '/api/v1/d2bild0010/printBillMulti'
      } else if (kariFlg === true) {
        path = '/api/v1/d2bild0010/printBillKariMulti'
      }
      this.selected = this.removeFilterTable(this.selected)
      this.HttpClient.post(path, this.selected)
        .then((data) => {
          const printDataList = data.payload
          if (printDataList.length === 0) {
            this.loadFromCache()
              .then((c) => {
                this.conditions = c.value.conditions || {}
                this.onSearchButtonClick()
              })
              .then(() => {
                if (data.summaryMessage) {
                  data.isValid ? this.setInvalidSummaryMessage('BILE0008') : this.setInvalidSummaryMessage(data.summaryMessage.messageCd)
                } else {
                  this.setInvalidSummaryMessage('BILE0008')
                }
                this.Effects.loadComplete()
              })
          } else {
            let cnt = 0
            printDataList.forEach(p => {
              this.HttpClient.requestFileByPostReturnData('/api/v1/d2bild0010/downloadBill', p).then((param) => {
                // aタグにファイル仕込んでClickする処理
                const blob = new Blob([param.data], { type: 'application/pdf' })
                const elem = document.getElementById('seikyushoDownload')
                const targetSeikyuNo = param.headers['content-disposition'].match(/filename=(.*);/)[1]
                const printData = printDataList.find((p) => {
                  return p.seikyuNo === targetSeikyuNo
                })
                elem.download = `${printData.seikyuYm}月度_${printData.torihikisakiNm}_請求書_${this.getTimeStamp()}.pdf`
                elem.href = window.URL.createObjectURL(blob)
                elem.click()

                cnt++
                if (cnt === printDataList.length) {
                  this.loadFromCache()
                    .then((c) => {
                      this.conditions = c.value.conditions || {}
                      this.onSearchButtonClick()
                    })
                    .then(() => {
                      if (data.summaryMessage) {
                        data.isValid ? this.setInvalidSummaryMessage('COMI0007') : this.setInvalidSummaryMessage(data.summaryMessage.messageCd)
                      } else {
                        this.setInvalidSummaryMessage('COMI0007')
                      }
                      this.Effects.loadComplete()
                    })
                }
              })
            })
          }
        })
    },
    onPrintAgainButtonClick: function (e) {
      this.clearSummaryMessage()

      var checkResult = this.checkSelected('出力済')
      if (checkResult !== '') {
        this.setInvalidSummaryMessage('BILE0005')
        return false
      }
      this.Effects.loadStart()
      this.selected = this.removeFilterTable(this.selected)
      this.HttpClient.post('/api/v1/d2bild0010/printBillAgainMulti', this.selected)
        .then((data) => {
          const pathList = data.payload
          if (pathList.length === 0) {
            this.loadFromCache()
              .then((c) => {
                this.conditions = c.value.conditions || {}
                this.onSearchButtonClick()
              })
              .then(() => {
                if (data.summaryMessage) {
                  data.isValid ? this.setInvalidSummaryMessage('BILE0008') : this.setInvalidSummaryMessage(data.summaryMessage.messageCd)
                } else {
                  this.setInvalidSummaryMessage('BILE0008')
                }
                this.Effects.loadComplete()
              })
          } else {
            let cnt = 0
            pathList.forEach(p => {
              this.HttpClient.requestFileByPostReturnData('/api/v1/d2bild0010/downloadBill', p).then((param) => {
                // this.dispSeikyusho = `${p.seikyuYm}月度_${p.torihikisakiNm}_請求書_${this.getTimeStamp()}.pdf`
                // aタグにファイル仕込んでClickする処理
                const blob = new Blob([param.data], { type: 'application/pdf' })
                const elem = document.getElementById('seikyushoDownload')
                const targetSeikyuNo = param.headers['content-disposition'].match(/filename=(.*);/)[1]
                const printData = pathList.find((p) => {
                  return p.seikyuNo === targetSeikyuNo
                })
                elem.download = `${printData.seikyuYm}月度_${printData.torihikisakiNm}_請求書_${this.getTimeStamp()}.pdf`
                elem.href = window.URL.createObjectURL(blob)
                elem.click()

                cnt++
                if (cnt === pathList.length) {
                  this.loadFromCache()
                    .then((c) => {
                      this.conditions = c.value.conditions || {}
                      this.onSearchButtonClick()
                    })
                    .then(() => {
                      if (data.summaryMessage) {
                        data.isValid ? this.setInvalidSummaryMessage('COMI0007') : this.setInvalidSummaryMessage(data.summaryMessage.messageCd)
                      } else {
                        this.setInvalidSummaryMessage('COMI0007')
                      }
                      this.Effects.loadComplete()
                    })
                }
              })
            })
          }
        })
    },
    searchValidate: function () {
      var checkRes1 = this.shimeDayCheck()
      var checkRes2 = this.shiborikomiDateCheck()
      if (!checkRes1 || !checkRes2) { return false }
      if (this.conditions.seikyuYm) {
        if (this.conditions.seikyuYm.length !== 7) {
          this.$refs.seikyuYm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0012'))
          return false
        }
      }
      return true
    },
    shimeDayCheck: function () {
      if (this.conditions.shimeDay === '') { return true }
      var shimebi = parseInt(this.conditions.shimeDay)
      if ((shimebi >= 32 && shimebi <= 98) || shimebi === 0) {
        this.$refs.shimeDay[this.Ctrls.SET_INVALID_METHOD](message.get('BILV0001'))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      return true
    },
    shiborikomiDateCheck: function () {
      if (this.conditions.shiborikomiStartDay === '' && this.conditions.shiborikomiEndDay === '') { return true }

      if (!this.conditions.seikyuYm) {
        this.$refs.seikyuYm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0119', ['絞込日付', '請求年月']))
        this.setInvalidSummaryMessage('COME0012')
        return false
      }

      if (!this.conditions.shiborikomiStartDay) {
        this.$refs.shiborikomiStartDay[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0119', ['絞込日付(To)', '絞込日付(From)']))
        this.setInvalidSummaryMessage('COME0012')
        return false
      }

      if (!this.conditions.shiborikomiEndDay) {
        this.$refs.shiborikomiEndDay[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0119', ['絞込日付(From)', '絞込日付(To)']))
        this.setInvalidSummaryMessage('COME0012')
        return false
      }

      var shiborikomiStart = parseInt(this.conditions.shiborikomiStartDay)
      if ((shiborikomiStart >= 32 && shiborikomiStart <= 98) || shiborikomiStart === 0) {
        this.$refs.shiborikomiStartDay[this.Ctrls.SET_INVALID_METHOD](message.get('BILV0001'))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }

      var shiborikomiEnd = parseInt(this.conditions.shiborikomiEndDay)
      if ((shiborikomiEnd >= 32 && shiborikomiEnd <= 98) || shiborikomiEnd === 0) {
        this.$refs.shiborikomiEndDay[this.Ctrls.SET_INVALID_METHOD](message.get('BILV0001'))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      return true
    },
    checkSelected (type) {
      for (const row of this.selected) {
        if (row.seikyusho !== type) { return row.seikyusho }
      }
      return ''
    },
    checkShimeJisseki () {
      for (const row of this.selected) {
        if (row.seikyuYmd <= this.lastShimeYmd) { return row.seikyuYmd }
      }
      return ''
    },
    setSeikyushoColor (seikyusho) {
      if (seikyusho === '取消済') return 'red--text'
      else if (seikyusho === '出力済') return 'blue--text'
    },
    removeFilterTable (data) {
      // 金額項目の','と'円'を削除する
      return data.map((elem) => {
        elem.konkaiSeikyuKingaku = this.removeFilterKingaku(elem.konkaiSeikyuKingaku)
        elem.kihonUnchiGokei = this.removeFilterKingaku(elem.kihonUnchiGokei)
        elem.warimashiKingakuGokei = this.removeFilterKingaku(elem.warimashiKingakuGokei)
        elem.kazeiKingakuGokei = this.removeFilterKingaku(elem.kazeiKingakuGokei)
        elem.konkaiTax = this.removeFilterKingaku(elem.konkaiTax)
        elem.hiwayPriceGokei = this.removeFilterKingaku(elem.hiwayPriceGokei)
        elem.uchizeiKingakuGokei = this.removeFilterKingaku(elem.uchizeiKingakuGokei)
        elem.hikazeiKingakuGokei = this.removeFilterKingaku(elem.hikazeiKingakuGokei)
        // 合計出力しないフラグを埋め込む
        elem.nonOutputSummaryFlg = this.conditions.nonOutputSummaryFlg
        return elem
      })
    },
    removeFilterKingaku (dispKingaku) {
      var target = dispKingaku.replace('円', '')
      if (target.length > 3) {
        target = target.replace(/,/g, '')
      }
      return target
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    },
    getSystemConfigInfo: function () {
      var systemConfig = this.systemConfigList.filter((t) => {
        return t.configName === 'seikyu_meisai_shiyo_flg'
      })
      if (systemConfig.length > 0 && systemConfig[0].configValue1 === 'NO') {
        return false
      } else {
        return true
      }
    },
    checkDate: function (seikyuYm, day) {
      var y = ('0000' + seikyuYm.split('/')[0]).slice(-4)
      var targetMonth = ('00' + seikyuYm.split('/')[1]).slice(-2)
      var m = targetMonth - 1
      var d = ('00' + day).slice(-2)
      var date = new Date(y, m, d)
      var resultYear = ('0000' + date.getFullYear()).slice(-4)
      var resultMonth = ('00' + (date.getMonth() + 1)).slice(-2)
      var resultDay = ('00' + date.getDate()).slice(-2)

      console.log(resultYear, resultMonth, resultDay)
      if (resultYear !== y || resultMonth !== targetMonth || resultDay !== d) {
        return false
      }
      return true
    },
    getShimeJisseki: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get('/api/v1/TrKessanGetsujiKanri/GetAll')
          .then((data) => {
            if (data.payload) {
              var seikyuShimeList = data.payload.map((elem) => {
                elem.taishoShimeYmd = new Date(elem.taishoYm + '/' + elem.taishoShimeDay)
                return elem
              }).filter(function (elem) {
                return elem.taishoGyomuCd === '01' && elem.delFlg === false
              })
              this.lastShimeYmd = seikyuShimeList.length !== 0 ? filter.dateFormatter(seikyuShimeList[seikyuShimeList.length - 1].taishoShimeYmd) : ''
            }
            resolve()
          })
      })
    },
    onApplyButtonClick: function () {
      if (this.balkOperation === '取消') {
        this.onCancelButtonClick()
      } else if (this.balkOperation === '請求書仮発行') {
        this.onPrintButtonClick(true)
      } else if (this.balkOperation === '請求書再発行') {
        this.onPrintAgainButtonClick()
      } else if (this.balkOperation === '請求書発行') {
        this.onPrintButtonClick(false)
      }
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
